module.exports = function() {
  return new Worker(__webpack_public_path__ + "5d6292eabf22851c9e69.worker.js");
};